<template>
  <div class="jobRemote column justify-center align-center"></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: { modal: Object },
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.jobRemote {
  width: 300px;
  padding: 32px 15px;
  padding-bottom: 15px;
  text-align: center;
  font-family: Work Sans;

  @media (max-width: $small) {
    width: auto;
  }

  .title {
    font-weight: 600;
    font-size: 22px;
    line-height: 24px;
    margin-bottom: 12px;
  }
}
</style>